<div class="nav-container">
  <nav id="main-menu-navigation" class="navigation-main">
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/Profile']"
      >
        <!-- <img src="assets/images/ava.png" class="img-fluid"
                    alt="SEU"> -->
        <img
          src="assets/images/icons/laptop-icon.svg"
          alt="laptop icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>الملف الشخصي</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/ViewSpecialistPatient']"
      >
        <!-- <img src="assets/images/medical-file.png"
                    class="img-fluid" alt="SEU"> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span> قائمة المرضى الخاصة بى</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/ViewAllSpecialistPatient']"
      >
        <!-- <img src="assets/images/medical-file.png"
                    class="img-fluid" alt="SEU"> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span> قائمة كل المرضى</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/My-Schedule']"
      >
        <!-- <img src="assets/images/medical-file.png" class="img-fluid"
                    alt="SEU"> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>عرض حالة حجوزات الجلسات بالتاريخ</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/UpcommingBookings']"
      >
        <!-- <img src="assets/images/medical-file.png" class="img-fluid"
                    alt="SEU"> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>الحجوزات القادمة</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/Schedule']"
      >
        <!-- <img src="assets/images/medical-file.png" class="img-fluid"
                    alt="SEU"> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>تحديد توقيت المواعيد المتاحة </span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/SpecialistReports']"
      >
        <!-- <img src="assets/images/medical-file.png" class="img-fluid"
                    alt="SEU"> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>التقارير الطبية</span></a
      >
    </div>

    <!-- خدمة مستشارك في التخاطب -->
    <div
      class="nav-item has-sub"
      routerLinkActive="active"
      *ngIf="specialist.joinedInYourConsultant"
    >
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/contacts.png" class="img-fluid" alt="SEU"> -->
        <img
          src="assets/images/icons/calling-icon.svg"
          alt="calling icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>خدمة مستشارك في التخاطب</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/ConsultantScheduleGenerate']"
        >
          <!-- <img src="assets/images/cal2.png" class="img-fluid"
                alt="SEU"> -->
          <img
            src="assets/images/icons/calendar-icon2.svg"
            alt="calendar icon"
            class="img-fluid"
            style="width: 24px"
          />
          <span>تحديد المواعيد المتاحة</span></a
        >
      </div>
    </div>
  </nav>
</div>
